export const isTrialSubscriptionCode = (subscriptionCode?: string | null): boolean => (
  (subscriptionCode ?? '').toLowerCase().includes('trial')
);
